module.exports = __webpack_public_path__ + "img/cn-sim.f6609864.svg";